import React from 'react';
import PropTypes from 'prop-types';
import I18n from '@fiverr-private/fiverr_context/src/I18n';

const FooterItem = ({ itemName }) => (
    <div className="footer-item">
        <h3><I18n k={`category_page.footer.${itemName}.title`}/>
            <b> <I18n k={`category_page.footer.${itemName}.title_bold`}/></b>
        </h3>
        <p><I18n k={`category_page.footer.${itemName}.text`}/></p>
    </div>
);

FooterItem.propTypes = {
    itemName: PropTypes.string
};

export default FooterItem;